export function useJudgeBrHost() {
  const headers = useRequestHeaders()
  const noMenus = ['tool', 'marketing', '/creative', '/invite', '/tool/bloggers']
  // const hostName = 'br.gloda.vip'
  // const hostName = 'uat.gloda.vip'
  // const hostName = 'localhost'
  const hostNames = ['br.gloda.vip', 'br-uat.gloda.vip', 'localhost']
  const isBrHost = computed(() => {
    const host = headers.host ? headers.host : window?.location?.hostname
    if (host) {
      return hostNames.some(item => host.includes(item))
    }
    else {
      return false
    }
    // if (headers.host) {
    //   return headers.host.includes(hostName)
    // }
    // else if (window?.location) {
    //   return window.location?.hostname.includes(hostName)
    // }
    // else {
    //   return false
    // }
  })
  return {
    isBrHost,
    noMenus,
  }
}
